<template>
  <div class="YKEditorV2Container" ref="YKEditorV2ContainerRef">
    <div class="YKEditorV2"></div>
  </div>
</template>

<script>
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'
import { BASEURL } from '@/axios/baseUrlConfig.js'
import { debounce } from 'lodash'

// 设置字体大小
let fontSizeStyle = Quill.import('attributors/style/size') // 引入这个后会把样式写在style上
fontSizeStyle.whitelist = ['14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '36px', '48px', '72px']
Quill.register(fontSizeStyle, true)
// 设置字体样式
let Font = Quill.import('attributors/style/font') // 引入这个后会把样式写在style上
let fonts = [false, 'SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial']
Font.whitelist = fonts // 将字体加入到白名单
Quill.register(Font, true)

const titleConfig = {
  'ql-bold': '加粗',
  'ql-color': '颜色',
  'ql-font': '字体',
  'ql-code': '插入代码',
  'ql-italic': '斜体',
  'ql-link': '添加链接',
  'ql-background': '颜色',
  'ql-size': '字体大小',
  'ql-strike': '删除线',
  'ql-script': '上标/下标',
  'ql-underline': '下划线',
  'ql-blockquote': '引用',
  'ql-header': '标题',
  'ql-indent': '缩进',
  'ql-list': '列表',
  'ql-align': '文本对齐',
  'ql-direction': '文本方向',
  'ql-code-block': '代码块',
  'ql-formula': '公式',
  // 'ql-image': '图片',
  // 'ql-video': '视频',
  'ql-clean': '清除字体样式',
  // 'ql-upload': '文件',
  'ql-table': '插入表格',
  'ql-table-insert-row': '插入行',
  'ql-table-insert-column': '插入列',
  'ql-table-delete-row': '删除行',
  'ql-table-delete-column': '删除列',
  'ql-sourceEditor': '源码编辑'
}
export default {
  name: 'editorQuill',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 400
    }
  },
  data() {
    return {
      content: '',
      quill: null,
      options: {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
              ['blockquote', 'code-block'], // 引用  代码块
              [{ header: 1 }, { header: 2 }], // 1、2 级标题
              [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
              [{ script: 'sub' }, { script: 'super' }], // 上标/下标
              [{ indent: '-1' }, { indent: '+1' }], // 缩进
              [{ direction: 'rtl' }], // 文本方向
              [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
              // [{ font: [] }], // 字体
              [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
              [{ size: ['14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '36px', '48px', '72px'] }], // 字体大小
              [{ font: ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong'] }], // 字体
              [{ align: [] }], // 对齐方式
              ['clean'], // 清除文本格式
              // ["link","image"], // 链接、图片、视频
              ['sourceEditor'], //新添加的工具
              [
                { table: 'TD' },
                { 'table-insert-row': 'TIR' },
                { 'table-insert-column': 'TIC' },
                { 'table-delete-row': 'TDR' },
                { 'table-delete-column': 'TDC' }
              ]
            ],
            handlers: {
              'table': function() {
                this.quill.getModule('table').insertTable(3, 3)
              },
              'table-insert-row': function() {
                this.quill.getModule('table').insertRowBelow()
              },
              'table-insert-column': function() {
                this.quill.getModule('table').insertColumnRight()
              },
              'table-delete-row': function() {
                this.quill.getModule('table').deleteRow()
              },
              'table-delete-column': function() {
                this.quill.getModule('table').deleteColumn()
              },
              'sourceEditor': function() {
                //添加工具方法
                const reg = /<br>/g,
                  container = this.container,
                  firstChild = container.nextElementSibling.firstChild
                if (!this.shadeBox) {
                  let shadeBox = (this.shadeBox = document.createElement('div'))
                  shadeBox.style.cssText =
                    'position:absolute; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); cursor:pointer'
                  container.style.position = 'relative'
                  shadeBox.addEventListener(
                    'click',
                    function() {
                      this.style.display = 'none'
                      firstChild.innerHTML = firstChild.innerText.trim()
                    },
                    false
                  )
                  container.appendChild(shadeBox)
                  let innerHTML = firstChild.innerHTML
                  innerHTML = innerHTML.replace(reg, '')
                  firstChild.innerText = innerHTML
                } else {
                  let innerHTML = firstChild.innerHTML
                  innerHTML = innerHTML.replace(reg, '')
                  firstChild.innerText = innerHTML
                  this.shadeBox.style.display = 'block'
                }
              }
            }
          },
          table: true
        },
        // readOnly: true, //是否只读
        placeholder: ''
      },
      // 防抖适应
      debounceResetEditorHeight: null,

      // 监听容器宽度
      resizeObserver: null,
      debounceHandleResize: null
    }
  },
  mounted() {
    // 挂载富文本
    const dom = this.$el.querySelector('.YKEditorV2')
    this.quill = new Quill(dom, this.options)

    // 粘贴事件捕获, 如果是图片拦截事件, 并自定义上传方法
    // 在捕获阶段被触发, 否则会被组件本身的事件先拦截
    this.quill.root.addEventListener(
      'paste',
      evt => {
        if (evt.clipboardData && evt.clipboardData.files && evt.clipboardData.files.length) {
          evt.preventDefault()
          const ar = []
          ar.forEach.call(evt.clipboardData.files, file => {
            if (!file.type.match(/^image\/(gif|jpe?g|a?png|bmp)/i)) {
              return
            }
            this.uploadToServer(file)
          })
        }
      },
      true
    )

    // this.quill.clipboard.dangerouslyPasteHTML(0, this.value) // html格式数据

    // 监听文本内容变化
    this.quill.on('text-change', () => {
      if (this.quill.root.innerHTML === '<p><br></p>') {
        this.content = ''
      } else {
        this.content = this.quill.root.innerHTML
      }
      this.$emit('change', this.content)
    })

    // 挂载拓展按钮
    this.$el.querySelector(
      '.ql-table-insert-row'
    ).innerHTML = `<svg t="1591862376726" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6306" width="18" height="200"><path d="M500.8 604.779L267.307 371.392l-45.227 45.27 278.741 278.613L779.307 416.66l-45.248-45.248z" p-id="6307"></path></svg>`
    this.$el.querySelector(
      '.ql-table-insert-column'
    ).innerHTML = `<svg t="1591862238963" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6509" width="18" height="200"><path d="M593.450667 512.128L360.064 278.613333l45.290667-45.226666 278.613333 278.762666L405.333333 790.613333l-45.226666-45.269333z" p-id="6510"></path></svg>`
    this.$el.querySelector(
      '.ql-table-delete-row'
    ).innerHTML = `<svg t="1591862253524" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6632" width="18" height="200"><path d="M500.8 461.909333L267.306667 695.296l-45.226667-45.269333 278.741333-278.613334L779.306667 650.026667l-45.248 45.226666z" p-id="6633"></path></svg>`
    this.$el.querySelector(
      '.ql-table-delete-column'
    ).innerHTML = `<svg t="1591862261059" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6755" width="18" height="200"><path d="M641.28 278.613333l-45.226667-45.226666-278.634666 278.762666 278.613333 278.485334 45.248-45.269334-233.365333-233.237333z" p-id="6756"></path></svg>`
    this.$el.querySelector('.ql-sourceEditor').innerHTML = `<i class="el-icon-edit"></i>`
    this.addQuillTitle()

    this.debounceResetEditorHeight = debounce(this.resetEditorHeight, 50)

    // 创建 ResizeObserver 实例
    this.debounceHandleResize = debounce(entries => this.handleResize(entries), 50)
    this.resizeObserver = new ResizeObserver(this.debounceHandleResize)

    // 开始观察 .YKEditorV2Container 元素
    if (this.$refs.YKEditorV2ContainerRef) {
      this.resizeObserver.observe(this.$refs.YKEditorV2ContainerRef)
    }
  },
  activated() {},
  methods: {
    // 容器宽度发生变化
    handleResize(entries) {
      for (let entry of entries) {
        const { width } = entry.contentRect
        // 在这里处理宽度变化,例如调用 resetEditorHeight 方法
        this.resetEditorHeight(width)
      }
    },
    // 获取guid
    guid() {
      var guid = ''
      for (var i = 1; i <= 32; i++) {
        var n = Math.floor(Math.random() * 16.0).toString(16)
        guid += n
        if (i === 8 || i === 12 || i === 16 || i === 20) guid += '-'
      }
      return guid
    },
    // 挂载拓展按钮
    addQuillTitle() {
      const oToolBar = document.querySelector('.ql-toolbar')
      const aButton = oToolBar.querySelectorAll('button')
      const aSelect = oToolBar.querySelectorAll('select')
      aButton.forEach(function(item) {
        if (item.className === 'ql-script') {
          item.value === 'sub' ? (item.title = '下标') : (item.title = '上标')
        } else if (item.className === 'ql-indent') {
          item.value === '+1' ? (item.title = '向右缩进') : (item.title = '向左缩进')
        } else {
          item.title = titleConfig[item.classList[0]]
        }
      })
      aSelect.forEach(function(item) {
        item.parentNode.title = titleConfig[item.classList[0]]
      })
    },
    // 获取富文本内容
    getContentData() {
      return this.quill.getContents()
    },
    // 修改粘贴图片为上传到服务器
    uploadToServer(file) {
      const that = this
      that.uploadSingle(file)
    },

    // 上传一个文件
    async uploadSingle(fileObj) {
      let upload = BASEURL.upload
      if (!upload) {
        upload = window.location.origin
      }
      const that = this
      const guID = that.guid()
      let formData = new FormData()
      formData.append('file', fileObj)
      formData.append('vuePathName', '')
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'accept-language': 'zh-CN'
        },
        timeout: 0
      }
      const { data: res } = await that.$http.post(`${upload}/upload?X-Progress-ID=${guID}`, formData, config)
      if (res.isSuccess) {
        that.uploadComplete(res.data)
      } else {
        that.$message.error(res.errorMessage)
      }
    },

    // 上传完毕后
    uploadComplete(data) {
      let upload = BASEURL.upload
      if (!upload) {
        upload = window.location.origin
      }
      let quill = this.quill
      let length = quill.getSelection(true).index
      //这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。
      quill.insertEmbed(length, 'image', `${upload}/downloadnew/${data.aPath}`)
      quill.setSelection(length + 1)
    },

    resetEditorHeight() {
      if (this.quill) {
        // console.log(this.quill.container.offsetHeight)
        // 默认高度
        let toolbarHeight = 42
        const toolbarDOM = this.$refs.YKEditorV2ContainerRef.querySelector('.ql-toolbar')
        if (toolbarDOM && toolbarDOM.offsetHeight > 0) {
          toolbarHeight = toolbarDOM.offsetHeight
        }

        this.quill.container.style.height = `${this.height + 2 - toolbarHeight}px`
      }
    }
  },
  computed: {
    inputHeight() {
      return this.height
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal !== this.content) {
          this.content = newVal
          if (this.quill) {
            this.quill.root.innerHTML = this.content
            // this.quill.root.innerHTML = ''
            // if (this.content) {
            //   this.quill.clipboard.dangerouslyPasteHTML(0, this.content)
            // }
          }
        }
      },
      immediate: true
    },
    inputHeight: {
      handler() {
        this.debounceResetEditorHeight()
      }
    }
  }
}
</script>

<style lang="less" scoped></style>
